import { Injectable } from '@angular/core';
import {
  FileUploadContext,
  FileUploadControlComponentDelegate,
} from '@fry/components/common/file-upload-control';


export interface UserFileUploadContext extends FileUploadContext {
  fileTypes?: string[];
  maxFileSizeMB?: number;
  maxFileCount?: number;
  allowMultiple?: boolean;
}

@Injectable()
export class UserFileUploadDelegate implements FileUploadControlComponentDelegate {

  private context: UserFileUploadContext | null = null;

  constructor(
  ) { }

  setContext(context: UserFileUploadContext) {
    this.context = context;
  }

  getContext(): UserFileUploadContext | null {
    return this.context;
  }
}
